<div class="title">
  <span>{{ 'realtime:editReservedPreferred' | i18next }}</span>
     <i id="close-btn-change-reserved-agent-dialog" class="close-icon" mat-button cdkFocusInitial [mat-dialog-close]="false" (click)="closeDialog()"></i>
</div>

<div class="dialog-content">
  <!-- Options -->
  <div class="options">
    <app-basic-radio id="radio-change-agent-change-reserved-agent-dialog" name="opt" [(model)]="option" value="change" [label]="'realtime:queuedetails_lang_changeagent' | i18next ">
    </app-basic-radio>
      <app-basic-radio id="radio-remove-agent-change-reserved-agent-dialog" name="opt" [(model)]="option" value="remove" [label]="'realtime:queuedetails_lang_removeagent' | i18next ">
    </app-basic-radio>
  </div>

  <!-- Search -->
  <div class="search-row" *ngIf="option === 'change'">
      <app-basic-textbox
      id="agent-query-input-change-reserved-agent-dialog"
      type="text"
      [(model)]="agentQuery"
      width="380px"
      [placeholder]="'realtime:queuedetails_lang_enteragent' | i18next"
    />
    <app-basic-button id="search-agent-btn-change-reserved-agent-dialog" (click)="onSearchAgent()"  type="secondary" isIcon="true" size="medium" [disabled]="!agentQuery?.trim() || loading">
    <i class="fal fa-search fs-14"></i>
    </app-basic-button>
  </div>

  <!-- Selected preview -->
  <div class="selected-preview" *ngIf="option === 'change'">

    <div class="preview-label">{{ 'realtime:queuedetails_lang_newagent' | i18next }} </div>
    <div class="preview-input">{{selectedAgent?.name || ''}}</div>
  </div>

  <!-- Results -->
  <table class="sq-table" *ngIf="option === 'change' && agentList?.length; else noDataBlock">
    <thead>
      <tr>
        <th class="left">{{ 'realtime:queuedetails_lang_name' | i18next }}</th>
        <th class="left">{{ 'realtime:queuedetails_lang_usergroup' | i18next }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let a of agentList"
          (click)="selectAgent(a)"
          [class.selected]="a.id === selectedAgent?.id">
        <td class="left">{{ a.name }}</td>
        <td class="left">{{ '(' + a.groupname + ')' }}</td>
      </tr>
    </tbody>
  </table>

  <div *ngIf="option === 'remove'">
    {{ 'realtime:queuedetails_deleteAgent' | i18next }}
  </div>

  <ng-template #noDataBlock>
    <div class="no-items-short" *ngIf="option === 'change' && searched && !agentList?.length && !loading">{{ 'realtime:noResults' | i18next }}</div>
  </ng-template>

  <!-- Error -->
  <div class="error" *ngIf="errorKey">{{ errorKey | i18next }}</div>
</div>

<mat-dialog-actions>
  <app-basic-button id="close-btn-change-reserved-agent-dialog" type="secondary" size="small" (click)="closeDialog()">
    {{ 'translation:Close' | i18next }}
  </app-basic-button>
  <app-basic-button id="save-btn-change-reserved-agent-dialog" type="primary" size="small"(click)="onSave()" [disabled]="loading || (option === 'change' && !selectedAgent)">
    {{ 'realtime:queuedetails_lang_savechanges' | i18next }}
  </app-basic-button>
</mat-dialog-actions>
